(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_header-mobile-dropdown"] && !Shopify.designMode) return;
  try {
    class HeaderMobileDropdown extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.hmd-trigger');
    this.content = this.querySelector('.hmd-content');
    this.isOpen = false;
    
    if (this.trigger && this.content) {
      this.trigger.addEventListener('click', this.toggle.bind(this));
      
      // 外側クリックで閉じる
      document.addEventListener('click', (e) => {
        if (this.isOpen && !this.contains(e.target)) {
          this.close();
        }
      });
    }
  }
  
  toggle() {
    if (this.isOpen) {
      this.close();
    } else {
      this.open();
    }
  }
  
  open() {
    this.isOpen = true;
    this.classList.add('is-open');
    const height = this.content.scrollHeight;

    this.content.style.maxHeight = 500 + 'px';
    /* (height >= 500 ? height - 80 : height - 30) + 'px'; */
  }
  
  close() {
    this.isOpen = false;
    this.classList.remove('is-open');
    this.content.style.maxHeight = '0';
  }
}

customElements.define('header-mobile-dropdown', HeaderMobileDropdown);
  } catch(e) { console.error(e); }
})();

})();
